import React from 'react';
import { get, find } from 'lodash';
import { Redirect } from 'react-router-dom';
import { useTranslate } from 'core/translate';
import FeaturesCompare from './FeaturesCompare';

const getHeaderData = (config, trims, driveType, bodyTypeId, engineId) => {
  if (!driveType || !bodyTypeId || !engineId) {
    return null;
  }

  const engineDescription = get(
    find(config.engines, { id: engineId }),
    'description'
  );
  const bodyTypeDescription = get(
    find(config.bodyTypes, { id: bodyTypeId }),
    'formattedConfig'
  );
  const driveTypeDescription = find(config.driveTypes, { id: driveType })
    ? driveType
    : null;
  const firstOption = find(trims.options, {
    driveType: driveType,
    bodyTypeId: bodyTypeId
  });

  const result = {
    primaryText: bodyTypeDescription,
    secondaryText: driveTypeDescription,
    tertiaryText: engineDescription
  };

  if (firstOption) {
    result.imageUrl = firstOption.image;
  }

  return result;
};

const CapabilitiesCompare = props => {
  const translate = useTranslate();
  const {
    location,
    match,
    config,
    features,
    trimFeatures,
    disclaimer,
    lockDefaultColumn,
    onSelect,
    onSectionsChange
  } = props;
  const { engineRowData, groups } = features;

  const searchParams = new URLSearchParams(location.search);

  if (
    !searchParams.has('engineOne') ||
    !searchParams.has('driveTypeOne') ||
    !searchParams.has('bodyTypeOne')
  ) {
    const { engine, driveType, bodyTypeId } = config.selections;
    searchParams.set('engineOne', engine);
    searchParams.set('driveTypeOne', driveType);
    searchParams.set('bodyTypeOne', bodyTypeId);
    return <Redirect to={`${match.url}?${searchParams.toString()}`} />;
  }

  const engineOne = searchParams.get('engineOne');
  const engineTwo = searchParams.get('engineTwo');
  const engineThree = searchParams.get('engineThree');
  const driveTypeOne = searchParams.get('driveTypeOne');
  const driveTypeTwo = searchParams.get('driveTypeTwo');
  const driveTypeThree = searchParams.get('driveTypeThree');
  const bodyTypeOne = searchParams.get('bodyTypeOne');
  const bodyTypeTwo = searchParams.get('bodyTypeTwo');
  const bodyTypeThree = searchParams.get('bodyTypeThree');
  const sections = searchParams.getAll('section');

  const toColumn = (bodyType, driveType, engine) => {
    const id = `${bodyType}_${driveType}_${engine}`;
    return get(engineRowData, id);
  };

  const columns = [
    toColumn(bodyTypeOne, driveTypeOne, engineOne),
    toColumn(bodyTypeTwo, driveTypeTwo, engineTwo),
    toColumn(bodyTypeThree, driveTypeThree, engineThree)
  ];

  const toHeader = (bodyType, driveType, engine) =>
    getHeaderData(config, trimFeatures, driveType, bodyType, engine);

  const headers = [
    toHeader(bodyTypeOne, driveTypeOne, engineOne),
    toHeader(bodyTypeTwo, driveTypeTwo, engineTwo),
    toHeader(bodyTypeThree, driveTypeThree, engineThree)
  ];

  return (
    <FeaturesCompare
      featureGroups={groups}
      columns={columns}
      headers={headers}
      defaultSections={sections}
      lockDefaultColumn={lockDefaultColumn}
      disclaimer={disclaimer}
      placeholderText={translate('component.trim.compare.add.capabilities')}
      analyticsKey="compare capabilities"
      onSelect={onSelect}
      onSectionsChange={onSectionsChange}
    />
  );
};

export default CapabilitiesCompare;
